import gql from 'graphql-tag';

export const CREATE_PAYMENT = gql`
  mutation($input: CreatePaymentInput!) {
    createPayment(input: $input) {
      paymentId
    }
  }
`;
export const UPDATE_PAYMENT = gql`
  mutation($input: UpdatePaymentInput!) {
    updatePayment(input: $input) {
      paymentId
    }
  }
`;

export const DELETE_PAYMENT = gql`
  mutation($input: PaymentIdentifierInput!) {
    deletePayment(input: $input)
  }
`;
